import { ACTIV8_TABS } from '../../../constants';
import { changeActiv8Tab } from '../../../redux/activ8/activ8Reducer';
import { clearBeforeInit, setSelectedMedia, setSelectedMediaActiveId } from '../../../redux/story/storyReducer';
import { normalizeFromFavorite } from '../../story/media/storyMediaItem';

export function resolveFavoriteId(favoriteId) {
  return favoriteId?.id ?? favoriteId ?? null;
}

export function fromFavoriteToStoryMedia(favoriteItem) {
  return normalizeFromFavorite({
    id: favoriteItem.id,
    mediaType: favoriteItem.mediaType,
  });
}

export function navigateToStoryWithFavorite(dispatch, favoriteItem) {
  const media = fromFavoriteToStoryMedia(favoriteItem);

  dispatch(clearBeforeInit());
  dispatch(setSelectedMedia([media]));
  dispatch(setSelectedMediaActiveId(media.sourceId));
  dispatch(changeActiv8Tab(ACTIV8_TABS.STORY));
}
